import React from "react"
import { firestore } from "../../core"
import { useUsers } from "popopo-lib-front/firestore-access"
import { NavLink } from "react-router-dom"
import { Paths } from "../../paths"
import { UserId } from "popopo-msg"


export const UserList = () => {
  const users = useUsers(firestore, 100)

  return (
    <>
      <ul className="list-group w-100">
        {users === "loading" ? (
          <li>
            <i className="fas fa-spin fa-spinner" />
          </li>
        ) : users.length === 0 ? (
          <li>ユーザーは1人も存在しません。</li>
        ) : (
          users.map((user) => (
            <li key={user.id} className="list-group-item">
              <NavLink to={Paths.users.user.getPath(UserId(user.id))}>
                ID: {user.id} (Created at: {user.created_at})
              </NavLink>
            </li>
          ))
        )}
      </ul>
    </>
  )
}
